/* app/js/src/components/destinations/destination-settings/destination-youtube-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.destination-settings-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0 0.5rem 2.25rem;
}
.destination-settings-form__dropdown-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem 2rem;
  width: 100% !important;
  max-width: 100%;
}
.destination-settings-form__dropdown-row .ts-action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  flex: 0 1 auto;
}
.destination-settings-form__dropdown-row .ts-action .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  width: auto;
}
.destination-settings-form__dropdown-row .ts-action icn-dropdown {
  width: 14rem;
  min-width: 10rem;
}
.destination-settings-form__checkbox-row {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
  width: 100% !important;
}
.destination-settings-form__checkbox-row .ts-action {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.destination-settings-form__checkbox-row .ts-action .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.destination-settings-form__quota-note {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: rgb(255, 180, 0);
}
.destination-settings-form--readonly .destination-settings-form__checkbox-row .ts-action,
.destination-settings-form--readonly .destination-settings-form__dropdown-row .ts-action {
  opacity: 0.85;
}
.destination-settings-form--clipping-sidebar .destination-settings-form__checkbox-row {
  gap: 6px;
}
.destination-settings-form--clipping-sidebar .destination-settings-form__checkbox-row .ts-action {
  gap: 8px;
}
.destination-settings-form--clipping-sidebar .destination-settings-form__checkbox-row .ts-action .label {
  font-size: 12px;
  font-weight: 400;
}
.destination-settings-form--clipping-sidebar ::ng-deep .mat-mdc-checkbox {
  --mdc-checkbox-selected-checkmark-color: rgb(255, 255, 255);
  --mdc-checkbox-selected-focus-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-hover-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-pressed-icon-color: rgb(45, 187, 252);
}
.destination-settings-form--clipping-sidebar ::ng-deep .mdc-checkbox__ripple,
.destination-settings-form--clipping-sidebar ::ng-deep .mat-mdc-checkbox-ripple,
.destination-settings-form--clipping-sidebar ::ng-deep .mat-mdc-focus-indicator {
  display: none;
}
/*# sourceMappingURL=destination-youtube-settings.component.css.map */
